// extracted by mini-css-extract-plugin
export var standaloneTable = "_ds-0";
export var standaloneTableWithBodyFill = "_ds-1";
export var withExtraHeader = "_ds-2";